/**
 * Centralized confetti utilities for FrenFlow — DISABLED 2026-06-10.
 *
 * All celebration confetti was removed across the app at the user's
 * request (the lime-heavy bursts clashed with the de-lime pass). These
 * exports are kept as no-ops so the ~20 call sites keep compiling and
 * importing unchanged — flip the bodies back on here if confetti is ever
 * wanted again (git history has the original canvas-confetti impl).
 *
 * NOTE: BubbleFlow's in-game top-3 confetti is a separate canvas particle
 * system (bubbleflow/BubblesClient.tsx) and is NOT affected by this module.
 * The direct `canvas-confetti` calls in MigrationModal / OnboardingModal
 * were removed at their call sites (they don't route through here).
 */

// No-op stub that mimics the canvas-confetti callable shape: the instance
// returned by getConfettiModule() is invoked directly, and also via
// `.create(canvas, opts)` → callable instance with `.reset()` (RedeemModal,
// DFlowRedeemableCard). Keeping the shape avoids touching those call sites.
function makeNoopConfetti(): any {
  const fire: any = () => Promise.resolve();
  fire.reset = () => {};
  fire.create = () => {
    const instance: any = () => Promise.resolve();
    instance.reset = () => {};
    return instance;
  };
  return fire;
}

/** No-op (was: single-burst confetti). */
export async function celebrateSimple(): Promise<void> {
  /* confetti disabled 2026-06-10 */
}

/** No-op (was: button-anchored confetti). */
export async function celebrateFromElement(
  _el?: HTMLElement | null,
): Promise<void> {
  /* confetti disabled 2026-06-10 */
}

/** No-op (was: multi-burst confetti). Returns a no-op cleanup fn. */
export async function celebrateBurst(_duration = 3000): Promise<() => void> {
  return () => {};
}

// Legacy alias kept for backward compatibility.
export const celebrateWithConfetti = celebrateBurst;

/** No-op (was: generic confetti with custom options). */
export async function triggerConfetti(_options?: {
  particleCount?: number;
  spread?: number;
  origin?: { x?: number; y?: number };
  colors?: string[];
  startVelocity?: number;
  ticks?: number;
  zIndex?: number;
  angle?: number;
  gravity?: number;
  scalar?: number;
  drift?: number;
  decay?: number;
}): Promise<void> {
  /* confetti disabled 2026-06-10 */
}

/**
 * Returns a no-op stub shaped like the canvas-confetti module (callable +
 * `.create()` + `.reset()`) so existing `getConfettiModule()` consumers
 * (DailySpinModal, RedeemModal, DFlowRedeemableCard) keep working silently.
 */
export async function getConfettiModule(): Promise<any> {
  return makeNoopConfetti();
}
